import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import NoPortalDataIllustration from "./NoPortalData";
import IconComponent from "@CubeComponents/icons";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";

function QuickLinksTile({ widget }) {
  const userDetails = useSelector((state) => state.userDetails);
  const navigate = useNavigate();
  const [quickLinksMapper, setQuickLinksMapper] = useState({});
  const { t } = useTranslation();
  useEffect(() => {
    let widgetData;
    let quickLinkData = [];

    if (Object.keys(widget.selectedData).length) {
      widgetData = widget.selectedData;
      quickLinkData = Object.keys(widgetData)?.map((key) => {
        const output = {
          ...widgetData[key],
        };
        if (widgetData[key].type == "orgSettings" && userDetails.company?.id) {
          output.path = `/companySettings/${userDetails.company.id}/details`;
        }
        return output;
      });
    }
    setQuickLinksMapper(quickLinkData);
  }, [userDetails, widget]);

  const outputDataResult = () => {
    if (Object.keys(quickLinksMapper).length > 0) {
      return (
        <div className="flex flex-wrap gap-3 pt-3 ps-4">
          {Object.keys(quickLinksMapper)?.map((mapperKey) => (
            <Box
              className="flex items-center gap-3 p-1 cursor-pointer text-lg w-72  "
              onClick={() => {
                navigate(quickLinksMapper[mapperKey].path);
              }}
              key={quickLinksMapper[mapperKey].name}
            >
              <IconComponent name={quickLinksMapper[mapperKey].icon} />
              <div className="whitespace-nowrap overflow-hidden text-ellipsis">{quickLinksMapper[mapperKey].name}</div>
            </Box>
          ))}
        </div>
      );
    }
    return <NoPortalDataIllustration name={t("Modules")} />;
  };

  return outputDataResult();
}

export default QuickLinksTile;
